import React from 'react';
import './Dashboard.css';
import AIAssistant from './AIAssistant';
import ActionsTracker from './ActionsTracker';
import { useAuth } from '../hooks/useAuth';

const Dashboard = ({ accounts }) => {
  const { user } = useAuth();
  
  // Get dynamic greeting based on Eastern time
  const getGreeting = () => {
    const now = new Date();
    const easternTime = new Date(now.toLocaleString("en-US", {timeZone: "America/New_York"}));
    const hour = easternTime.getHours();
    
    if (hour >= 22 || hour <= 2) {
      // 10 PM - 2 AM
      return 'Burning the midnight oil eh';
    } else if (hour >= 3 && hour <= 5) {
      // 3 AM - 5 AM
      return 'Early bird catches the worm';
    } else if (hour >= 6 && hour <= 11) {
      // 6 AM - 11 AM
      return 'Good morning';
    } else if (hour >= 12 && hour <= 16) {
      // 12 PM - 4 PM
      return 'Good afternoon';
    } else if (hour >= 17 && hour <= 19) {
      // 5 PM - 7 PM
      return 'Good evening';
    } else {
      // 8 PM - 9 PM
      return 'Still going strong';
    }
  };
  
  // Calculate overview metrics
  const totalAccounts = Object.keys(accounts).length;
  const healthyCount = Object.values(accounts).filter(a => a.status === 'healthy').length;
  const neutralCount = Object.values(accounts).filter(a => a.status === 'neutral').length;
  const atRiskCount = Object.values(accounts).filter(a => a.status === 'unhealthy').length;
  const totalTickets = Object.values(accounts).reduce((sum, a) => sum + a.tickets.length, 0);

  return (
    <div className="dashboard-view">
      <div className="welcome-section">
        <h2>{getGreeting()}, {user?.name?.split(' ')[0] || 'there'}!</h2>
        <p>Here's an overview of your customer accounts</p>
        
        <div className="overview-grid">
          <div className="overview-card">
            <h3>Total Accounts</h3>
            <div className="value">{totalAccounts}</div>
          </div>
          <div className="overview-card">
            <h3>Healthy Accounts</h3>
            <div className="value">{healthyCount}</div>
          </div>
          <div className="overview-card">
            <h3>Accounts at Risk</h3>
            <div className="value">{atRiskCount + neutralCount}</div>
          </div>
          <div className="overview-card">
            <h3>Open Tickets</h3>
            <div className="value">{totalTickets}</div>
          </div>
        </div>
      </div>

      <div className="dashboard-modules">
        <AIAssistant accounts={accounts} />
        <ActionsTracker />
      </div>
    </div>
  );
};

export default Dashboard;